import React from "react"
import { connect } from "react-redux"
import { message, Upload, Select as AntSelect } from "antd"
import { Row, Col } from "reactstrap"
import { Button } from "@mui/material"
import ValidatorForm, {
    Select,
    TextField,
    Switch,
    ChipsInput,
    DateTimePicker,
    MultiSelect,
} from "../ValidatorForm"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import Auxiliary from "../../util/Auxiliary"
import {
    uploadCsv
} from "../../appRedux/slices/content"
import _ from "lodash"
import toastr from "toastr"
import "./content.styles.css"
import { MdOutlineUpload } from "react-icons/md"
class CsvUpload extends ErrorBoundComponent {
    state = {
        formData: {
            date: "",
            isDefault: false,
            uploadType: "fan"
        }
    }

    componentDidMount() {
    }

    _uploadCSV = fileObj => {
        if (fileObj.file) {
            this.setState({
                csvFileList: [
                    {
                        uid: "-1",
                        name: fileObj.file.name,
                        status: "done",
                        url: "",
                    },
                ],
                csvFile: fileObj.file,
            })
        }
    }

    _onVideoRemove = () => {
        this.setState({
            csvFileList: [],
            csvFile: null,
        })
    }

    _form = () => {
        return (
            <ValidatorForm
                onSubmit={this._onSubmit}
                layout={"vertical"}
                {...this._formLayout}
            >
                <Row className="align-items-center flex-nowrap">
                    <Col xs="auto" className="me-2">
                        <p className="text-muted mb-0">Select Csv Type</p>
                    </Col>
                    <Col xs="auto" className="me-3">
                        <Select
                            placeholderLabel="Select an upload type"
                            field="uploadType"
                            className="creator-form"
                            validations={["required"]}
                            errors={["This field is required"]}
                            defaultValue={this.state.formData.uploadType}
                            onChange={value => this.setState(prevState => ({
                                formData: {
                                    ...prevState.formData,
                                    uploadType: value
                                }
                            }))}
                            options={[
                                { label: "User Fan Count", value: "fan" },
                                { label: "Feed Priority Items", value: "priorityitems" },
                                { label: "Challenge Like", value: "challengeLike" },
                                { label: "Challenge View", value: "challengeView" },
                                { label: "Content Like", value: "contentLike" },
                                { label: "Content View", value: "contentView" }
                            ]}
                        />
                    </Col>

                    {this.state.formData.uploadType == "priorityitems" && (<Col xs="auto" className="me-3 d-flex align-items-center">
                        <p className="text-muted mb-0 me-2">DEFAULT</p>
                        <Switch
                            checked={this.state.formData.isDefault}
                            onChange={value =>
                                this.setState(prevState => ({
                                    formData: {
                                        ...prevState.formData,
                                        isDefault: value
                                    }
                                }))
                            }
                        />
                    </Col>)}

                    {this.state.formData.uploadType == "priorityitems" && !this.state.formData.isDefault && (
                        <>
                            <Col xs="auto" className="me-2">
                                <p className="text-muted mb-0">Select Date</p>
                            </Col>
                            <Col xs="auto" className="me-3">
                                <input
                                    type="date"
                                    className="form-control"
                                    value={this.state.formData.date || ""}
                                    onChange={e =>
                                        this.setState(prevState => ({
                                            formData: {
                                                ...prevState.formData,
                                                date: e.target.value
                                            }
                                        }))
                                    }
                                />
                            </Col>
                        </>
                    )}
                    <Col xs="auto" className="me-3">
                        <Upload
                            showUploadList={true}
                            onRemove={this._onVideoRemove}
                            defaultFileList={this.state.csvFileList}
                            fileList={this.state.csvFileList}
                            customRequest={this._uploadCSV}
                        >
                            <Button
                                color="info"
                                variant="contained"
                                startIcon={<MdOutlineUpload />}
                            >
                                Upload CSV
                            </Button>
                        </Upload>
                    </Col>

                    <Col xs="auto" className="ms-auto">
                        <Button
                            variant="contained"
                            type="submit"
                            color="success"
                            disabled={this.state.loading}
                            onDoubleClick={e => {
                                e.preventDefault()
                                e.stopPropagation()
                            }}
                        >
                            Upload
                        </Button>
                    </Col>
                </Row>

            </ValidatorForm>
        )
    }

    _onSubmit = async ({ formData, errors }) => {
        if (errors) {
            return
        }

        if (this.props.currentUser && !this.props.currentUser.otpVerified) {
            toastr.error("OTP not verified!!", "")
            return
        }

        formData.bulk_upload = true

        let data = new FormData()
        data.append("file", this.state.csvFile)
        console.log(JSON.stringify(this.state.formData))
        data.append("details", JSON.stringify(this.state.formData))

        this.props.dispatch(uploadCsv(data))
        // this.props.onCancel()
    }

    render() {
        return (
            <Auxiliary
                loading={this.props.loading}
                error={_.get(this.props, "common.error")}
            >
                {this._form()}
            </Auxiliary>
        )
    }
}

function mapStateToProps(store, ownProps) {
    return {
        loading: _.get(store, "content.loading"),
        common: _.get(store, "common"),
        currentUser: _.get(store, "currentUser.currentUser.data"),
        cmsUserList: _.get(store, "cmsUser.user"),
        // curatedTypes: _.get(store, "content.curatedTypes")
    }
}

export default connect(mapStateToProps)(CsvUpload)
